import { render, staticRenderFns } from "./pointsAndLevel.vue?vue&type=template&id=08e12302&"
import script from "./pointsAndLevel.vue?vue&type=script&lang=js&"
export * from "./pointsAndLevel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports